<template>
    <div class="account-register">
      <div class="font-s36 c06 text-center">找回密码</div>
      <div class="account-contents">
               <div class="account-userinfo">
                    <el-row>
                        <el-input placeholder="请输入手机号码" v-model="username" autofocus="autofocus"></el-input>
                    </el-row>
                    <el-row class="pd-t-20">
                        <el-col :span="17">
                            <el-input placeholder="请输入验证码" v-model="authCode"></el-input>
                        </el-col>
                        <el-col :span="6">
                            <el-button type="info" plain  class="auth-code font-s18 c99" @click="authCodeBtn" :disabled="disabledCode">{{authCodeTxt}}</el-button>
                        </el-col>
                    </el-row>
                     <el-row class="pd-t-20">
                        <el-input placeholder="请设置6-12位密码" v-model="pwd"  type="password"></el-input>
                    </el-row>
                     <el-row class="pd-t-20">
                        <el-input placeholder="请再次输入密码" v-model="confirmPwd"  type="password"></el-input>
                    </el-row>
                    <el-row class="hint">
                        <img src="../../assets/image/hint.png" class="middle" v-if="hint!=''">
                        {{hint}}
                    </el-row>
                    <el-row class="operation">
                        <el-button class="el-long login-btn"  @click="login" >修改密码</el-button>
                    </el-row>
                    <el-row class="other-operating">
                        <el-col :span="12">
                            <div @click="accountLogin">已有账号去登录</div>
                        </el-col>
                    </el-row>
                </div>
      </div>
    </div>
</template>

<script>
import { SendSmsCode } from "../../api/api";
import { ForgotPassword } from "../../api/api";
import { LoginOut } from "../../api/api";

export default {
  data() {
    return {
                //    item值
        //    telphone //手机号码
        //    from//从哪个页面转入   userCenter个人中心
      item:this.$route.query.item==undefined?'':JSON.parse(this.$route.query.item),
      username: "", //账户
      authCode: "", //验证码
      hint: "",
      pwd:'',//密码
      confirmPwd:'',//确认密码
      authCodeTxt:'获取验证码',//验证码按钮内容
      disabledCode:false//验证码是否可点击
    };
  },
  created(){
      if(this.item!=''){
          this.username=this.item.telphone;
      }
  },
  methods: {
     login() {
      var checkPhone = /^[0-9]{11}$/;
      if (this.username == ""  || checkPhone.test(this.username)==false) {
        this.hint = "请输入正确的手机号码";
      } else if (this.authCode == "") {
        this.hint = "请输入验证码";
      }else if(this.pwd == "" || this.pwd.length<6  || this.pwd.length>12){
        this.hint = "请输入6-12位密码";
      } 
      else if(this.confirmPwd == ""){
         this.hint = "请确认密码";
      }
      else {
        if(this.pwd == this.confirmPwd ){
            this.hint = "";
                var db = {
                    telphone:this.username,//	手机号
                    code	:this.authCode,//验证码
                    password	:this.pwd,//密码
                    repassword	:this.confirmPwd,//确认第二次密码
               };
            this.$axios.post(ForgotPassword, db).then(
            res => {
                if (res.data.code == 1) {
                    this.$axios.post(LoginOut,{}).then();
                    var item={
                        from:this.item.from//从哪个页面转入
                    }
                    this.$message({
                            type: 'success',
                        message: res.data.msg
                    });
                    this.$router.push({name:'userCenter',query:{item:JSON.stringify(this.item)}})
                } else {
                  this.hint = res.data.msg;
                }
            },
            err => {
                this.hint = err.data.msg;
            }
            );
        }
        else{
            this.hint = "两次密码不一致，请重新输入";
            this.confirmPwd='';
        }
      }
    },
    accountLogin(){ //已有账号去登录
     sessionStorage.removeItem("username");
     var item={
         from:this.item.from//从哪个页面转入
     }
     this.$router.push({name:'userCenter',query:{item:JSON.stringify(this.item)}})
    },
    authCodeBtn(){ //发送验证码
      var checkPhone = /^[0-9]{11}$/;
      if (this.username == "" || checkPhone.test(this.username)==false) {
        this.hint = "请输入正确的手机号码";
      }else{
        var db = {
          telphone: this.username
        };
        this.$axios.post(SendSmsCode, db).then(
        res => {
            if (res.data.code == 1) {
                this.disabledCode=true;
                var auth_time = 60;
                var auth_timetimer =  setInterval(()=>{
                    auth_time--;
                    if(auth_time<=0){
                        this.sendAuthCode = true;
                        clearInterval(auth_timetimer);
                        this.authCodeTxt='重新发送';
                        this.disabledCode=false;
                    }
                    else{
                        this.authCodeTxt=auth_time+'s'
                    }
                }, 1000);
            } else {
               this.authCode = "";
            }
        },
        err => {
            this.authCode = "";
        }
        );
      }
    },
  }
};
</script>

<style lang="scss">

</style>
